import { render } from "./FormProfile.vue?vue&type=template&id=d6a361a4&scoped=true"
import script from "./FormProfile.vue?vue&type=script&lang=js"
export * from "./FormProfile.vue?vue&type=script&lang=js"

import "./FormProfile.vue?vue&type=style&index=0&id=d6a361a4&scoped=true&lang=scss"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a361a4"]])

export default __exports__